type InfoProps = {
  children: string;
  Icon: React.FC;
};

export const Info: React.FC<InfoProps> = ({ children, Icon }) => (
  <div className="flex items-center gap-5">
    <div className="text-primary min-w-[24px] min-h-[24px] w-[24px] h-24px">
      <Icon />
    </div>
    <span className="text-gray-700">{children}</span>
  </div>
);
